// AUTO-GENERATED by tools/build/gen_advertised_formats.py from system-models/supported_filetypes.py::ADVERTISED_FORMATS.
// DO NOT EDIT — hand-edits are overwritten on the next `tools/build_all_ts.py` run.
// Regen: python3 tools/build/gen_advertised_formats.py
// Source of truth: system-models/supported_filetypes.py (ADVERTISED_FORMATS).
// Design: docs/epics/active/web-content-support-accuracy-260820/phase-2-copy-policy-260820.md §4.2 (DD-2).
export const ADVERTISED_FORMATS = [
    {
        formatName: "pdf",
        displayName: "PDF",
        extensions: [".pdf"],
        tier: "native-full",
        kind: "pdf",
        iconId: "icon-pdf",
        surfaces: ["api", "cli", "editor", "upload"],
        editable: true,
        remediable: true,
        forwardNote: null,
    },
    {
        formatName: "pptx",
        displayName: "PowerPoint",
        extensions: [".pptx"],
        tier: "native-full",
        kind: "presentations",
        iconId: "icon-pptx",
        surfaces: ["api", "cli", "editor", "upload"],
        editable: true,
        remediable: true,
        forwardNote: null,
    },
    {
        formatName: "docx",
        displayName: "Word",
        extensions: [".docx"],
        tier: "native-full",
        kind: "documents",
        iconId: "icon-docx",
        surfaces: ["api", "cli", "editor", "upload"],
        editable: true,
        remediable: true,
        forwardNote: null,
    },
    {
        formatName: "xlsx",
        displayName: "Excel",
        extensions: [".xlsx"],
        tier: "native-full",
        kind: "spreadsheets",
        iconId: "icon-xlsx",
        surfaces: ["api", "cli", "editor", "upload"],
        editable: true,
        remediable: true,
        forwardNote: null,
    },
    {
        formatName: "odp",
        displayName: "LibreOffice Impress",
        extensions: [".odp"],
        tier: "remediate-live",
        kind: "presentations",
        iconId: "icon-odp",
        surfaces: ["api", "cli", "editor", "upload"],
        editable: true,
        remediable: true,
        forwardNote: "Remediates today via one-click upload and the accessibility editor (alt text, decorative marking, document language, slide titles). Idempotent re-run, provenance stamping, and the change log are coming for OpenDocument.",
    },
    {
        formatName: "latex",
        displayName: "LaTeX",
        extensions: [".tex"],
        tier: "cli-only",
        kind: "documents",
        iconId: "icon-latex",
        surfaces: ["cli"],
        editable: false,
        remediable: true,
        forwardNote: "Runs through the command-line tool today; a drop-in web upload is planned. No editable view for LaTeX.",
    },
    {
        formatName: "odt",
        displayName: "LibreOffice Writer",
        extensions: [".odt"],
        tier: "remediate-upload",
        kind: "documents",
        iconId: "icon-odt",
        surfaces: ["api", "cli", "upload"],
        editable: false,
        remediable: true,
        forwardNote: "Remediates today via one-click upload: DocAble adds image alt text, marks decorative images, sets the document language, and fills in the document title. Idempotent re-run, provenance stamping, and the change log are coming for OpenDocument; there is no editable accessibility view for Writer yet.",
    },
    {
        formatName: "ods",
        displayName: "LibreOffice Calc",
        extensions: [".ods"],
        tier: "remediate-upload",
        kind: "spreadsheets",
        iconId: "icon-ods",
        surfaces: ["api", "cli", "upload"],
        editable: false,
        remediable: true,
        forwardNote: "Remediates today via one-click upload: DocAble adds image alt text, marks decorative images, sets the document language, and fills in the document title. Idempotent re-run, provenance stamping, and the change log are coming for OpenDocument; there is no editable accessibility view for Calc yet.",
    },
];
export const ADVERTISED_BY_KIND = [
    {
        kind: "documents",
        label: "Documents",
        formats: [
            {
                formatName: "docx",
                displayName: "Word",
                extensions: [".docx"],
                tier: "native-full",
                kind: "documents",
                iconId: "icon-docx",
                surfaces: ["api", "cli", "editor", "upload"],
                editable: true,
                remediable: true,
                forwardNote: null,
            },
            {
                formatName: "latex",
                displayName: "LaTeX",
                extensions: [".tex"],
                tier: "cli-only",
                kind: "documents",
                iconId: "icon-latex",
                surfaces: ["cli"],
                editable: false,
                remediable: true,
                forwardNote: "Runs through the command-line tool today; a drop-in web upload is planned. No editable view for LaTeX.",
            },
            {
                formatName: "odt",
                displayName: "LibreOffice Writer",
                extensions: [".odt"],
                tier: "remediate-upload",
                kind: "documents",
                iconId: "icon-odt",
                surfaces: ["api", "cli", "upload"],
                editable: false,
                remediable: true,
                forwardNote: "Remediates today via one-click upload: DocAble adds image alt text, marks decorative images, sets the document language, and fills in the document title. Idempotent re-run, provenance stamping, and the change log are coming for OpenDocument; there is no editable accessibility view for Writer yet.",
            },
        ],
    },
    {
        kind: "presentations",
        label: "Presentations",
        formats: [
            {
                formatName: "pptx",
                displayName: "PowerPoint",
                extensions: [".pptx"],
                tier: "native-full",
                kind: "presentations",
                iconId: "icon-pptx",
                surfaces: ["api", "cli", "editor", "upload"],
                editable: true,
                remediable: true,
                forwardNote: null,
            },
            {
                formatName: "odp",
                displayName: "LibreOffice Impress",
                extensions: [".odp"],
                tier: "remediate-live",
                kind: "presentations",
                iconId: "icon-odp",
                surfaces: ["api", "cli", "editor", "upload"],
                editable: true,
                remediable: true,
                forwardNote: "Remediates today via one-click upload and the accessibility editor (alt text, decorative marking, document language, slide titles). Idempotent re-run, provenance stamping, and the change log are coming for OpenDocument.",
            },
        ],
    },
    {
        kind: "spreadsheets",
        label: "Spreadsheets",
        formats: [
            {
                formatName: "xlsx",
                displayName: "Excel",
                extensions: [".xlsx"],
                tier: "native-full",
                kind: "spreadsheets",
                iconId: "icon-xlsx",
                surfaces: ["api", "cli", "editor", "upload"],
                editable: true,
                remediable: true,
                forwardNote: null,
            },
            {
                formatName: "ods",
                displayName: "LibreOffice Calc",
                extensions: [".ods"],
                tier: "remediate-upload",
                kind: "spreadsheets",
                iconId: "icon-ods",
                surfaces: ["api", "cli", "upload"],
                editable: false,
                remediable: true,
                forwardNote: "Remediates today via one-click upload: DocAble adds image alt text, marks decorative images, sets the document language, and fills in the document title. Idempotent re-run, provenance stamping, and the change log are coming for OpenDocument; there is no editable accessibility view for Calc yet.",
            },
        ],
    },
    {
        kind: "pdf",
        label: "PDF",
        formats: [
            {
                formatName: "pdf",
                displayName: "PDF",
                extensions: [".pdf"],
                tier: "native-full",
                kind: "pdf",
                iconId: "icon-pdf",
                surfaces: ["api", "cli", "editor", "upload"],
                editable: true,
                remediable: true,
                forwardNote: null,
            },
        ],
    },
];
